// extracted by mini-css-extract-plugin
export default {"asterisk":"asterisk---ModM_"};